import type { ReactElement } from 'react';

export type ConfirmBadgeState = 'unclassified' | 'ai-classified' | 'confirmed';

export interface ConfirmBadgeProps {
  readonly state: ConfirmBadgeState;
}

// Re-uses the V1 .badge-* classes already defined in web/src/index.css.
// `badge-classify` = orange (AI), `badge-complete` = green (user-confirmed),
// `badge-draft` = neutral (no classification yet).
const STATE_CONFIG: Readonly<
  Record<ConfirmBadgeState, { readonly label: string; readonly badgeClass: string }>
> = Object.freeze({
  unclassified: { label: 'Unclassified', badgeClass: 'badge-draft' },
  'ai-classified': { label: 'AI-classified', badgeClass: 'badge-classify' },
  confirmed: { label: '✓ Confirmed', badgeClass: 'badge-complete' },
});

export function ConfirmBadge({ state }: ConfirmBadgeProps): ReactElement {
  const cfg = STATE_CONFIG[state];
  return <span className={`badge ${cfg.badgeClass}`}>{cfg.label}</span>;
}
